import * as Helpers from '../../helpers';

import { LOADING, ERROR } from './user';

export const PROCESSOR_GET = 'PROCESSOR_GET';
export const WITHDRAWAL_GET = 'WITHDRAWAL_GET';
export const WITHDRAWAL_VERIFY = 'WITHDRAWAL_VERIFY';
export const WITHDRAW = 'WITHDRAW';
export const WITHDRAWAL_SET_OFFSET = 'WITHDRAWAL_SET_OFFSET';
export const WITHDRAWAL_CLEAR = 'WITHDRAWAL_CLEAR';
export const WITHDRAWAL_GET_ACCOUNTS = 'WITHDRAWAL_GET_ACCOUNTS';
export const WITHDRAWAL_ADD_ACCOUNT = 'WITHDRAWAL_ADD_ACCOUNT';

export const getProcessors = () => Helpers.api(
  '/processors',
  'GET',
  null,
  {},
  { error: ERROR, loading: LOADING, responder: PROCESSOR_GET }
);

export const setWithdrawalOffset = (limit, offset) => dispatch => dispatch({ payload: { limit, offset }, type: WITHDRAWAL_SET_OFFSET });

export const getWithdrawals = (limit, offset, application_id, from, to, search, success) => {
  let url = `/withdrawal?limit=${limit || 10}&offset=${offset || 0}`;

  if (application_id) {
    url += `&application_id=${application_id}`;
  }
  if (from && to) {
    url += `&from=${from}&to=${to}`;
  }
  if (search && search.status) {
    const statusParam = Helpers.formatStatusParam(search.status);
    if (statusParam) {
      url += `&${statusParam}`;
    }
  }

  return Helpers.api(
    url,
    'GET',
    null,
    { success },
    {
      error: ERROR, loading: LOADING, responder: WITHDRAWAL_GET,
    }
  );
};

export const clearWithdrawals = () => dispatch => {
  dispatch({ type: WITHDRAWAL_CLEAR });
};

export const getAccounts = (user_id, processor_id, success, error) => Helpers.api(
  `/account?user_id=${user_id}&processor_id=${processor_id}`,
  'GET',
  null,
  { error, success },
  { error: ERROR, loading: LOADING, responder: WITHDRAWAL_GET_ACCOUNTS }
);

export const saveAccounts = (details, processor_id, saved_by_user, success, error) => Helpers.api(
  '/account/add',
  'POST',
  { details, processor_id, saved_by_user },
  { error, success },
  { error: ERROR, loading: LOADING, responder: WITHDRAWAL_ADD_ACCOUNT }
);

export const verifyWithdrawalDetails = (details, processor_id, success, error) => Helpers.api(
  '/withdrawal/verify',
  'POST',
  { details, processor_id },
  { error, success },
  { error: ERROR, loading: LOADING, responder: WITHDRAWAL_VERIFY }
);

export const withdraw = (amount, details, processor_id, save_by_user, application_id, success) => Helpers.api(
  '/withdrawal',
  'POST',
  {
    amount, application_id, details, processor_id, save_by_user,
  },
  { success },
  { error: ERROR, loading: LOADING, responder: WITHDRAW }
);
